var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteTiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.591929,
    y: 0.591929,
    width: 11.8161,
    height: 11.8161,
    rx: 1.77579,
    stroke: "white",
    strokeWidth: 1.18386
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.591929,
    y: 15.5919,
    width: 11.8161,
    height: 11.8161,
    rx: 1.77579,
    stroke: "white",
    strokeWidth: 1.18386
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5919,
    y: 0.591929,
    width: 11.8161,
    height: 11.8161,
    rx: 1.77579,
    stroke: "white",
    strokeWidth: 1.18386
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5919,
    y: 15.5919,
    width: 11.8161,
    height: 11.8161,
    rx: 1.77579,
    stroke: "white",
    strokeWidth: 1.18386
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTiles);
export default __webpack_public_path__ + "static/media/white_tiles.5ddf075936e95798e59e5296e86dc795.svg";
export { ForwardRef as ReactComponent };